import React, { useEffect, useState } from 'react';
import { List, Avatar, Typography, Button, Spin, Divider, Empty, Tooltip } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import CartApiService from '../../services/CartApiService';
import { useAuth } from '../../contexts/AuthContext';
import { Role } from '../../constants/Role';
import '../../styles/CartDropdown.css';
import { FORMAT_RGB } from 'antd/es/color-picker/interface';

const { Text } = Typography;

const CartDropdown = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { hasAnyRole } = useAuth();

  const ITEM_HEIGHT = 90;
  const MAX_VISIBLE_ITEMS = 4;
  const listHeight = Math.min(cartItems.length, MAX_VISIBLE_ITEMS) * ITEM_HEIGHT;

  const fetchCart = async () => {
    // Chỉ fetch cart cho role LEARNER
    if (!hasAnyRole([Role.LEARNER])) {
      setCartItems([]);
      setTotal(0);
      setLoading(false);
      return;
    }
    
    setLoading(true);
    try {
      const res = await CartApiService.getCart();
      const courses = res.data?.courses || [];
      // Sắp xếp theo addedAt mới nhất lên đầu
      const sortedCourses = [...courses].sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt));
      setCartItems(sortedCourses);
      localStorage.setItem('cartCache', JSON.stringify(sortedCourses)); // Lưu cache mới nhất
      const total = sortedCourses.reduce((sum, item) => sum + (item.price || 0), 0);
      setTotal(total);
    } catch (e) {
      setCartItems([]);
      setTotal(0);
    }
    setLoading(false);
  };

  // Fetch cart mỗi khi mở dropdown
  useEffect(() => {
    // Chỉ fetch cart cho role LEARNER
    if (!hasAnyRole([Role.LEARNER])) {
      setCartItems([]);
      setTotal(0);
      return;
    }
    
    // Lấy cache trước để hiển thị ngay
    const cache = localStorage.getItem('cartCache');
    if (cache) {
      const courses = JSON.parse(cache);
      // Sắp xếp theo addedAt mới nhất lên đầu
      const sortedCourses = [...courses].sort((a, b) => new Date(b.addedAt) - new Date(a.addedAt));
      setCartItems(sortedCourses);
      setTotal(sortedCourses.reduce((sum, item) => sum + (item.price || 0), 0));
    }
    fetchCart();
    const handleCartChanged = () => fetchCart();
    window.addEventListener('cart-changed', handleCartChanged);
    return () => window.removeEventListener('cart-changed', handleCartChanged);
  }, [hasAnyRole]);

  return (
    <div style={{ width: 288, padding: 8, paddingTop: 0, display: 'flex', flexDirection: 'column' }}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}><Spin /></div>
      ) : (!cartItems || !Array.isArray(cartItems) || cartItems.length === 0) ? (
        <div style={{ 
          width: '100%', 
          minHeight: 200, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: '20px 0'
        }}>
          <Empty description="Your cart is empty" />
        </div>
      ) : (
        <>
          <div style={{ height: listHeight, overflowY: cartItems.length >= MAX_VISIBLE_ITEMS ? 'auto' : 'visible', marginRight: -5  }}>
            <List
              itemLayout="horizontal"
              dataSource={cartItems}
              rowKey={item => item._id}
              style={{ height: '100%' }}
              renderItem={item => (
                <List.Item
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/courses/${item.slug}`)}
                >
                  <List.Item.Meta
                    avatar={<Avatar shape="square" size={48} src={item.imageUrl || undefined} style={{ background: '#eee', marginTop:7, marginLeft:8,marginRight:-3 }} />}
                    title={
                      <Tooltip title={item.name} placement="topLeft">
                        <Text strong ellipsis style={{ maxWidth: 170, cursor: 'pointer' }}>{item.name}</Text>
                      </Tooltip>
                    }
                    description={<div><Text type="secondary">{item.author}</Text><br /><Text>{item.price?.toLocaleString()} $</Text></div>}
                  />
                </List.Item>
              )}
            />
          </div>
          {/* <Divider style={{ margin: '0 0' }} /> */}
          <div
            style={{
              background: '#fff',
              borderRadius: 0,
              boxShadow: '0 4px 16px rgba(0,0,0,0.10)',
              padding: 16,
              
              marginTop: 3,
              border: '1px solid #f0f0f0',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              width: 'calc(99.4999% + 16px)',
              marginLeft: -8,
              marginRight: -8,
              marginBottom:-8,
              boxSizing: 'border-box'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5, boxShadow: 'rgba(0,0,0,0.10)',}}>
              <Text strong underline style={{ fontSize: 17 }}>Total:</Text>
              <Text strong style={{ fontSize: 17 }}>{total.toLocaleString()} $</Text>
            </div>
            {location.pathname !== '/cart' && location.pathname !== '/cart/checkout' && (
              <Button
                type="primary"
                block
                style={{
                  marginTop: 0,
                  
                 
                  fontWeight: 600,
                  fontSize: 15,
                  borderRadius: 12,
                  paddingBottom:0
                }}
                onClick={() => navigate('/cart')}
              >
                Move to cart
              </Button>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CartDropdown; 